import { render, staticRenderFns } from "./SearchSpeechs.html?vue&type=template&id=49fb99ec&scoped=true&external"
import script from "./SearchSpeechs.js?vue&type=script&lang=js&external"
export * from "./SearchSpeechs.js?vue&type=script&lang=js&external"
import style0 from "./SearchSpeechs.scss?vue&type=style&index=0&id=49fb99ec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb99ec",
  null
  
)

export default component.exports